var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-checkbox"},[_c('input',_vm._g(_vm._b({staticClass:"v-checkbox__input",class:{
            'v-checkbox__input--error': _vm.error,
            'v-checkbox__input--error-fatal': _vm.isFatalError,
            'v-checkbox__input--disabled': _vm.disabled,
        },attrs:{"id":_vm.id,"disabled":_vm.disabled,"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.value}},'input',_vm.$attrs,false),_vm.listeners)),_c('CheckSVG',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"v-checkbox__check"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }